<template>
<div>

    <!-- ------------------ Show Assign Tempo if any --------------------------- -->
    <div v-if="orderDetailObj.pickupVehicleAssignId && !onEdit">
        <Row>
            <Col span="5">Assigned to</Col>
            <Col span="10" class="assign-vehicle-detail" v-if="orderDetailObj.PIckupTempo">
                {{orderDetailObj.PIckupTempo.tempo.name}}
                <Icon id="assign-edit-icon" type="md-create" @click="onEdit=true"></Icon>
                <p class="vehicle-driver-name">{{orderDetailObj.PIckupTempo.driverDetail.name}}</p>
            </Col>
            <Col span="10" class="assign-vehicle-detail" v-if="orderDetailObj.PickupTruck">
                {{orderDetailObj.PickupTruck.truck.name}}
                <Icon id="assign-edit-icon" type="md-create" @click="onEdit=true"></Icon>
                <p class="vehicle-driver-name">{{orderDetailObj.PickupTruck.driverDetail.name}}</p>
            </Col>
        </Row>
    </div>
    <!-- -----------x-----------x----------x-----------x--------x---------x------ -->

    <!-- --------- If no tempo assign, show list of tempos available for that Order
                   AND even show the list when change assignment(onEdit) --------  -->
<!--  <div class="fixed-height-scroll">-->
    <div v-for="(tempoOrder, index) in tempoOrders"
         v-if="!orderDetailObj.pickupVehicleAssignId || (onEdit && tempoOrder.id!==orderDetailObj.pickupVehicleAssignId)">
        <Row>
            <Col span="18" class="vehicle-driver-name">
              <span style="color: #a9a9a9; margin-right: 4px;">Contractor</span>: {{tempoOrder.tempo.Contractor.name}}<br>           <!-- ↑ Exclude assignedTempoOrder from list in Edit-->
              <span style="color: #a9a9a9; margin-right: 4px;">Driver</span>: {{tempoOrder.driverDetail.name}}<br>
              <span style="color: #a9a9a9; margin-right: 4px;">Plate No</span>: {{tempoOrder.tempo.platNo}}<br>
              <span style="color: #a9a9a9; margin-right: 4px;">Type</span>: {{contractType[tempoOrder.tempo.Contractor.type]||''}}
              <template v-if="tempoOrder.tempo.type"><br><span style="color: #a9a9a9; margin-right: 4px;">Tempo Type</span>: {{tempoOrder.tempo.type}}</template>

            </Col>
            <Col span="6">
                <Poptip placement="right" v-model="popover[index]">
                    <Button class="assign-order-anchor">VIEW</Button>
                    <div slot="title">
          <span style="font-weight: bolder;font-size: 14px">
           OTHER ORDERS ({{tempoOrder.orderDetailsArr.length}})</span>
                    </div>
                    <div slot="content">
                        <template v-for="order in tempoOrder.orderDetailsArr">
                            {{order.order.orderNumber}}<br>
                            {{order.order.pickuppartyobject.name}} ↔ {{order.order.droppingpartyobject.name}}<br>
                            {{order.order.pickuppartyobject.address[0].city}} ↔ {{order.order.droppingpartyobject.address[0].city}}
                            <Divider></Divider>
                        </template>
                        <template v-if="!tempoOrder.orderDetailsArr.length">No Orders.</template>
                        <!--<Button type="success" size="small" @click="assignTempo(tempoOrder.id, index)">ASSIGN</Button>-->
                    </div>
                </Poptip>
                <Button type="success" style="margin-top: 2px" @click="assignTempo(tempoOrder.id, index)">ASSIGN</Button>
            </Col>
        </Row>
        <Divider v-if="onEdit || (index+1)!==tempoOrders.length"></Divider>
    </div>
<!--  </div>-->
    <!-- ------x---------x------------x---------x------------x----------x------------- -->

    <div v-if="(!orderDetailObj.pickupVehicleAssignId && !tempoOrders.length) ||
               (orderDetailObj.pickupVehicleAssignId && tempoOrders.length===1 && onEdit)">No Tempo available.</div>
    <Button v-if="onEdit" @click="onEdit=false" style="font-weight: bolder;">CANCEL UPDATION</Button>


</div>
</template>

<script>
import {GET_TEMPO_ORDERS_BY_DATE_AND_CITY} from '../../graphql/queries/tempoOrders'
import {SUBSCRIBE_TEMPO_ORDERS_BY_DATE_AND_CITY} from '../../graphql/subscription/tempoOrders'
import {ASSIGN_TEMPO} from '../../graphql/mutations/orderDetails'
import moment from 'moment'
import {contractType} from "../ExcelContractors/RendererFunctions";
    export default {
        apollo:{
            tempoOrders: {
                query: GET_TEMPO_ORDERS_BY_DATE_AND_CITY,
                variables(){
                    return{
                        // filterDate : moment(this.getOrder().pickupDate).format('YYYY-MM-DD'),
                        filterDate : moment().format('YYYY-MM-DD'),
                        // filterCity: this.getOrder().pickuppartyobject.address[0].city
                    }
                },
                subscribeToMore: {
                    document: SUBSCRIBE_TEMPO_ORDERS_BY_DATE_AND_CITY,
                    variables() {
                        return {
                            // filterDate : moment(this.getOrder().pickupDate).format('YYYY-MM-DD'),
                            filterDate : moment().format('YYYY-MM-DD'),
                            // filterCity: this.getOrder().pickuppartyobject.address[0].city
                        }
                    },
                    updateQuery: function(previousResult, { subscriptionData }) {
                        this.tempoOrders = subscriptionData.data.tempoOrders;
                    },
                },
                result ({ data, loading }) {
                    if (!loading) {
                        this.tempoOrders = data.tempoOrders;
                    }
                }
            },
        },
        name: "TempoAssignment",
        props:['orderDetailObj'],
        inject: ["getOrder","closeAssignVehicleDialog"],
        data: function(){
            return{
                mutation_ASSIGN_TEMPO: ASSIGN_TEMPO, /* Update OrderDetail by adding tempoOrderId */
                tempoOrders: [],
                popover: {},
                onEdit: false,   /* When need to change assignment */
                contractType: contractType,
            }
        },
        methods: {
            reset(){
                this.onEdit = false;
            },
            async assignTempo(tempoOrderId, popoverIndex){
                let response = await this.$apollo.mutate({
                    mutation: this.mutation_ASSIGN_TEMPO, /* Update OrderDetail by adding tempoOrderId */
                    variables: {
                        orderDetailId: this.orderDetailObj.id,
                        pickupVehicleAssignId: tempoOrderId
                    }
                })
                if(response.data){
                    this.$Message.success('Tempo assigned successfully!');
                    this.popover[popoverIndex] = false;
                    this.onEdit = false;
                    this.closeAssignVehicleDialog(false)
                }
            }
        }
    }
</script>

<style scoped>
.vehicle-driver-name{
    font-size: 14px;
    color: #62656b;
}
.assign-order-anchor{
    font-size: 12px;
    padding-left: 12px;
    font-weight: bolder;
}
.assign-vehicle-detail{
    border: 1px solid #d3d3d3;
    padding: 2px 0px 2px 10px;
    margin: -7px 0px 0px 0px;
}
#assign-edit-icon{
    visibility: hidden;
    margin-left: 4px;
}
.assign-vehicle-detail:hover #assign-edit-icon{
    visibility: visible;
}
.fixed-height-scroll{
  max-height: 200px;
  overflow-y: scroll;
}
</style>
